import { React, useEffect, useState } from 'react';
import '../../assets/css/productcard.css'
import './notAprrPCard.css';
import { Form } from 'react-bootstrap';
import { useAlert } from 'react-alert';
import RejectProductModal from './RejectProduct';
import { Modal } from 'react-bootstrap';
import '../../assets/css/modal.css'
import variables from '../../Variables.json'
import { NavLink} from "react-router-dom";


function NotAprrPCard(props) {

  const alert = useAlert()
  const [gst, setgst] = useState("");
  const [show, setShowModal] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [prodComb, setProdComb] = useState([]);
  const [currentComb, setCurrentComb] = useState({});
  const [combPending, setCombPending] = useState(0);
  //SL-699 Stock Popup
  const [stockPopupVisible, setStockPopupVisibility] = useState(false)
  //SL-699 Seller Stock
  const [inputStockValue, setInputStockValue] = useState(props.stock);
  const [stockError, setStockError] = useState(false);
  const [stockErrorMsg, setStockErrorMsg] = useState('');
  //SL-699
  const styles = {
    container: {
      stock: {
        marginTop: "10px"
      }
    },
    text: {
      currentStock: {
        position: "absolute",
        top: "-7px",
        left: "90px",
        background: "white",
        padding: "0px 5px",
        fontSize: "11px"
      },
      stockErrorMsg: {
        position: "relative",
        background: "white",
        padding: "0px 5px",
        fontSize: "12px",
        color: "red",

      }
    },

    input: {
      stock: {
        padding: "9px 22px 2px 11px",
        width: "150px"
      }
    }
  }

  /**
  * Validate the Stock Input Field
  * @returns 
  */
  const validateStockValue = () => {

    // Validation: Ensure the input is a positive number or zero
    if (!inputStockValue || inputStockValue == '' || inputStockValue == null || inputStockValue == undefined) {
      setStockError(true);
      setStockErrorMsg("Please enter a valid number.");
      return false;
    }
    else if (isNaN(inputStockValue)) {
      setStockError(true);
      setStockErrorMsg("Please enter a valid number.");
      return false;
    }
    else if (Number(inputStockValue) <= 0) {
      setStockError(true);
      setStockErrorMsg("Please enter a valid positive number.");
      return false;
    }
    else {
      setStockError(false);
      setStockErrorMsg('');
      return true;
    }
  }
  /**
   * SL - 699
   * Handle Stock Change
   * @param {*} id 
   * @param {*} value 
   */
  const handleStockChange = (stockValue) => {
    //Only allow numeric values
    if (/^\d*$/.test(stockValue)) {
      setStockError(false);
      setStockErrorMsg('');
      setInputStockValue(stockValue);
    }

  };


  /**
   * Handle click of approve with stock
   * @param {*} rsType 
   * @param {*} props 
   * @param {*} numericValue 
   */
  const handleStockUpdateSubmit = (rsType, props) => {
    if (validateStockValue()) {
      setStockPopupVisibility(false);
      props.handleProductUpdate(rsType, props, Number(inputStockValue), currentComb?.url);
    }



  }

  /**
   * Hid ethe stock popup
   */
  const onHide = () => {
    setStockPopupVisibility(false);
  }

  const handleClose = () => {
    setShowModal(false);
  }
  useEffect(() => {
    setgst("gst");
    setProdComb(props.combination);
    if (props.combination && props.combination.length > 0) {
      setCombPending(props.combination.length);
      setCurrentComb(props.combination[0])
    }
  }, [])

  /**
   * Handle the approve/reject case
   * @param {*} rType 
   * @param {*} id 
   */
  function handleProductStockUpdate(rType, id,stock,url,reason) {
    if (rType === "approve")
      setStockPopupVisibility(true);
    else
      props.handleProductUpdate(rType, id,stock,url,reason);
  }

  function handleProdCombUpdate(url) {
    const nextComb = [...prodComb];
    nextComb.map((pkg, index) => {
      if (pkg.url == url) {
        pkg.tmpSts = "approved";
        setCombPending(combPending - 1);
      }
    });
    setProdComb(nextComb);
    if (combPending === 1) {
      handleProductStockUpdate("approve", props);
    }
  }

  function requestnewPrice(id, tax) {
    let gst = document.getElementById(id + "gstPer").value;
    console.log(gst)
    if (gst === "gst") {
      alert.info("Please select GST %.")
    }
    else {
      props.requestnewPrice(id, gst)
      document.getElementById("req_price_again" + id).value = ""
    }
    setgst("gst")
  }

  function changeComb(e) {
    document.getElementById(`${props.id}price`).innerText = ` ${prodComb[e.value].price}`;
    setCurrentComb(prodComb[e.value]);
  }
  //SL-699 Stock Popup
  if (stockPopupVisible) {
    return (
      <Modal
        show={stockPopupVisible}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="">
          {
            <Modal.Header onClick={() => onHide(false)} className="close-design Confirmation-Modal-H fs-12" closeButton>
              <Modal.Title>Stock Update</Modal.Title>
            </Modal.Header>}

          <Modal.Body>
            {/*SL-699 Stock Popup Start */}
            {<div className="row" style={styles.container.stock}>
              <div className="col-12">
                <span style={styles.text.currentStock}>Current Stock</span>
                <input
                  type="number"
                  value={inputStockValue}
                  onChange={(e) => {
                    handleStockChange(e.target.value);

                  }}
                  style={styles.input.stock}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
              <div className='col-12'>
                {stockError && <span style={styles.text.stockErrorMsg}>{stockErrorMsg}</span>}
              </div>
            </div>}
            {/*SL-699 Stock Popup End */}
          </Modal.Body>
          <Modal.Footer>
            <div class="text-center detail-new bottom-action">
              <div className='text-center action-button'>
                <button className={'yes-button'} onClick={() => handleStockUpdateSubmit("approve", props)}>Submit</button>
              </div>
            </div>
          </Modal.Footer>
        </div>
      </Modal>

    )
  }
  else {
    if (props.from === "rejectedRecords") {

      if (props.combination && props.combination.length > 0) {
        return (
          <>
            <tr className='space color-row5 ord_table_row'>
              <td> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" /></td>
              <td className='fs-13 invent_table_pname_cntn'>
                <a href="#popupDetail" onClick={() => props.detail(props.id)}> {props.productName}</a>
                <p className='invent_table_sku mt-2'>SKU:- {props.SKU}</p>
                <p className="invent_table_sku mt-2 fw-bold">Combination requested :<mark>
                  {props.combination.length > 0 && props.combination.map((item, index) => {
                    return (
                      <span className="fs-11 fw-bold tools_168a86" key={index} value={`${props.id},${item.price}`}> {item.com}</span>
                    )
                  })}
                </mark>
                </p>
                {props.showButton && <a href='#popupDetail' style={{ margin: 10 }} onClick={() => props.detail(props.id)} class="detail-but float-right"><button class="px-1 order_table_btn_details">Details</button></a>}
              </td>
              <td><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {props.price}</span>
                <br></br>
                <span className="fs-12">(incl. GST)</span>

              </td>
              <td>{props.remark}</td>
              <td>
                <span className="invent_table_sku mt-2">Select GST % : <Form.Select size="sm" className="pro_card_comb_box_invent" id={props.id + "gstPer"} onChange={(e) => setgst(e.target.value)} value={gst}>
                  {["gst", ...variables?.variables?.gstValues].map((item, index) => {
                    return (
                      <option key={index} value={item}>{item} %</option>
                    )
                  })}
                </Form.Select></span>
                <br></br>
                <input type="number" placeholder='Enter price' className='w-90 pl-1 fs-14 mt-1' id={"req_price_again" + props.id} onWheel={(e) => e.target.blur()} />
                <br></br>
                <button className='req_again_btn' onClick={() => requestnewPrice(props.id, props.taxClass)}>Request again</button>
              </td>
            </tr>
          </>
        )
      }
      else {
        return (
          <>
            <tr className='space color-row5 ord_table_row'>
              <td> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" /></td>
              <td className='fs-13 invent_table_pname_cntn'>
                <a href="#popupDetail" onClick={() => props.detail(props.id)}> {props.productName}</a>
                <p className='invent_table_sku mt-2'>SKU:- {props.SKU}</p>
                {props.showButton && <a href='#popupDetail' style={{ marginRight: 10 }} onClick={() => props.detail(props.id)} class="detail-but float-right"><button class="px-1 order_table_btn_details">Details</button></a>}
              </td>
              <td><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {props.price}</span>
                <br></br>
                <span className="fs-12">(incl. GST)</span>
              </td>
              <td>{props.remark}</td>
              <td>
                <span className="invent_table_sku mt-2">Select GST % : <Form.Select size="sm" className="pro_card_comb_box_invent" id={props.id + "gstPer"} onChange={(e) => setgst(e.target.value)} value={gst}>
                  {["gst", ...variables?.variables?.gstValues].map((item, index) => {
                    return (
                      <option key={index} value={item}>{item} %</option>
                    )
                  })}
                </Form.Select></span>
                <br></br>
                <input type="number" placeholder='Enter price' className='w-90 pl-1 fs-14 mt-1' id={"req_price_again" + props.id} onWheel={(e) => e.target.blur()} />
                <br></br>
                <button className='req_again_btn' onClick={() => requestnewPrice(props.id, props.taxClass)}>Request again</button>
              </td>
            </tr>
          </>
        )
      }
    }
    else if (props.from === "pendingSellerApproval") {

      if (prodComb && prodComb.length > 0) {
        return (
          <>
            <tr className='space color-row5 ord_table_row' key={props?.id}>

              <td> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" /></td>
              <td className='fs-13 invent_table_pname_cntn'>
                <a href="#popupDetail" onClick={() => props.detail(props.id)}> {props.productName}</a>
                <p className='invent_table_sku mt-2'>SKU:- {props.SKU}</p>
                {/* <p className="invent_table_sku mt-2 fw-bold">Combination requested :<mark>
                  {props.combination.length > 0 && props.combination.map((item, index) => {
                    return (
                      <span className="fs-11 fw-bold tools_168a86" key={index} value={`${props.id},${item.price}`}> {item.com}</span>
                    )
                  })}
                </mark>
                </p> */}
                <p className="invent_table_sku mt-2">Combination's added :
                  <Form.Select size="sm" className="pro_card_comb_box_invent" onChange={(e) => changeComb(e.target)}>
                    {prodComb.length > 0 && prodComb.map((item, index) => {
                      return (
                        <option key={index} value={index}>{item.com}</option>
                      )
                    })}
                  </Form.Select>
                </p>
              </td>
              <td className='invent_pro_price'>
                <i className="fa fa-inr" aria-hidden="true"></i> <span id={`${props.id}price`}
                  className='invent_pro_price'>
                  {props.combination && props.combination[0] && props.combination[0].price ? props.combination[0].price : undefined}</span>
                <br></br>
                <span className="fs-12">(incl. GST)</span>
              </td>
              <td>
                {/* <span className="invent_table_sku mt-2">Select GST % : <Form.Select size="sm" className="pro_card_comb_box_invent" id={props.id + "gstPer"} onChange={(e)=>setgst(e.target.value)} value={gst}>
                  {["gst", 0, 5, 12, 18, 28].map((item, index) => {
                    return (
                      <option key={index} value={item}>{item} %</option>
                    )
                  })}
                </Form.Select></span>
                <br></br>
                <input type="number" placeholder='Enter price' className='w-90 pl-1 fs-14 mt-1' id={"req_price_again" + props.id} onWheel={(e)=>e.target.blur()}/>
                <br></br>
                <button className='req_again_btn' onClick={() => requestnewPrice(props.id, props.taxClass)}>Request again</button> */}

                {props.tmpSts == "forwarded-to-seller" && currentComb.tmpSts == undefined ? (
                  <div>
                    <span>Waiting for your approval</span>
                    <div style={{ marginTop: '30px' }}>
                      <button className='accept-product-but' onClick={() => props?.handleApprove(props)}>Approve</button>
                      <button className='reject-product-but' onClick={() => setShowModal(true)}>Reject</button>
                    </div>
                    <span style={{ color: 'red' }}>{combPending} attributes pending</span>


                    <input type="text" hidden value={reasonText} placeholder='Enter Reason' className='w-90 pl-1 fs-14 mt-1' id={"rjctReason" + props.lead} onWheel={(e) => e.target.blur()} readOnly />

                  </div>
                ) :
                  props.tmpSts == "forwarded-to-seller" && currentComb.tmpSts == "approved" ? (
                    <>
                      <span>Approved</span><br />
                      <span style={{ color: 'red' }}>{combPending} attributes pending</span>
                    </>
                  ) :
                    <span>Rejected</span>
                }
              </td>
              <td>{props.sellerRemarksHistory && props.sellerRemarksHistory.length > 0 && props.sellerRemarksHistory[props.sellerRemarksHistory.length - 1].reason}</td>
            </tr>
            <RejectProductModal
              show={show}
              handleClose={handleClose}
              setReasonText={setReasonText}
              handleConfirm={(reason) => handleProductStockUpdate("reject", props,"","",reason)}
            />
          </>
        )
      }
      else {
        return (
          <>

            <tr className='space color-row5 ord_table_row' key={props?.id}>

              <td> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" /></td>
              <td className='fs-13 invent_table_pname_cntn'>
                <a href="#popupDetail" onClick={() => props.detail(props.id)}> {props.productName}</a>
                <p className='invent_table_sku mt-2'>SKU:- {props.SKU}</p>
                {props.showButton && <a href='#popupDetail' style={{ marginRight: 10 }} onClick={() => props.detail(props.id)} class="detail-but float-right"><button class="px-1 order_table_btn_details">Details</button></a>}
              </td>
              <td className='invent_pro_price'><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {props.price}</span>
                <br></br>
                <span className="fs-12">(incl. GST)</span>
              </td>
              <td>
                {/* <span className="invent_table_sku mt-2">Select GST % : <Form.Select size="sm" className="pro_card_comb_box_invent" id={props.id + "gstPer"} onChange={(e)=>setgst(e.target.value)} value={gst}>
                  {["gst", 0, 5, 12, 18, 28].map((item, index) => {
                    return (
                      <option key={index} value={item}>{item} %</option>
                    )
                  })}
                </Form.Select></span>
                <br></br>
                <input type="number" placeholder='Enter price' className='w-90 pl-1 fs-14 mt-1' id={"req_price_again" + props.id} onWheel={(e)=>e.target.blur()}/>
                <br></br>
                <button className='req_again_btn' onClick={() => requestnewPrice(props.id, props.taxClass)}>Request again</button> */}
                {props.tmpSts == "forwarded-to-seller" ? (
                  <div>
                    <span>Waiting for your approval</span>
                    <div style={{ marginTop: '30px' }}>
                      <button className='accept-product-but' onClick={() => props?.handleApprove(props)}>Approve</button>
                      <button className='reject-product-but' onClick={() => setShowModal(true)}>Reject</button>
                    </div>
                    {/* <button className='req_again_btn' onClick={() => handleProductUpdate("approve", props)}><i class="fa fa-check" aria-hidden="true"></i></button> */}

                    <input type="text" hidden value={reasonText} placeholder='Enter Reason' className='w-90 pl-1 fs-14 mt-1' id={"rjctReason" + props.lead} onWheel={(e) => e.target.blur()} />
                    {/* <button className='req_again_btn' onClick={() => handleProductUpdate("reject", props)}><i class="fa fa-close" aria-hidden="true"></i></button> */}
                  </div>
                ) :
                  <span>Rejected</span>
                }

              </td>
              <td>{props.sellerRemarksHistory && props.sellerRemarksHistory.length > 0 && props.sellerRemarksHistory[props.sellerRemarksHistory.length - 1].reason}</td>
            </tr>
            <RejectProductModal
              show={show}
              handleClose={handleClose}
              setReasonText={setReasonText}
              handleConfirm={(reason) => handleProductStockUpdate("reject", props,"","",reason)}
            />
          </>
        )
      }
    }
    else {
      if (props.combination) {
        return (
          <>
            <tr className='space color-row5 ord_table_row'>
              <td> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" /></td>
              <td className='fs-13 invent_table_pname_cntn'>
                <a href="#"> {props.productName}</a>
                {props.showButton && <a href='#popupDetail' style={{ marginRight: 10 }} onClick={() => props.detail(props.id)} class="detail-but float-right"><button class="px-1 order_table_btn_details">Details</button></a>}
              </td>
              <td><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {props.price}</span>
                <br></br>
                <span className="fs-10">(incl. {props.taxClass}% GST)</span>
              </td>
              <td>{props.date}</td>
              <td>Pending for approval</td>
            </tr>
          </>
        )
      }
      else {
        return (
          <>
            <tr className='space color-row5 ord_table_row'>
              <td> <img src={"https://s3.toolsvilla.com/" + props.image} alt="img" className="px-2 product-i mx-1" /></td>
              <td className='fs-13 invent_table_pname_cntn'>
                <a href='#popupDetail' onClick={() => props.detail(props.id)}> {props.productName}</a>
                {props.showButton && <a href='#popupDetail' style={{ marginRight: 10 }} onClick={() => props.detail(props.id)} class="detail-but float-right"><button class="px-1 order_table_btn_details">Details</button></a>}
                 <NavLink to={`/edit-product1/${props.lead}`} >
                  <button  style={{ background: 'none', border: 'none' }}>&nbsp;<span style={{ color: '#168A86', fontSize: '12px' }}>  </span>
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style={{ marginRight: '5px' }}>
  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
  <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
</svg>                  </button>
                </NavLink>
              </td>
              <td><i class="fa fa-inr" aria-hidden="true"></i><span className="invent_pro_price"> {props.price}</span>
                <br></br>
                <span className="fs-10">(incl. {props.taxClass}% GST)</span>
              </td>
              <td>{props.date}</td>
              <td>
                {props.status === "rejected" ? (
                  <div>
                    <span>Rejected</span><br />
                    <span>{props.remark}</span><br />
                    <span>{props.actionDate}</span>
                  </div>
                ) :
                  <span>Pending for approval</span>
                }
              </td>
            </tr>
          </>
        )
      }
    }
  }


}
export default NotAprrPCard;